var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useFocused, useSelected } from "slate-react";
const DefaultChip = (props) => {
    const { attributes, children, style } = props, rest = __rest(props, ["attributes", "children", "style"]);
    const selected = useSelected();
    const focused = useFocused();
    return (_jsx("span", Object.assign({}, attributes, { style: Object.assign({ padding: "0px 4px 0px", margin: "0 1px", verticalAlign: "baseline", display: "inline-block", borderRadius: 4, color: "#4b4b4b", backgroundColor: "#dfdfdf", wordBreak: "break-word", boxShadow: selected && focused
                ? "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)"
                : "none", cursor: "pointer" }, style), contentEditable: false }, rest, { children: children })));
};
export default DefaultChip;
